export default __webpack_public_path__ + "static/media/12-100.93141600.jpg";